export const VARIABLE_MARKUP_RE = /#\*(.+?)\*#/g;

const HTML_ESCAPE_MAP: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};

export function escapeHtml(str: string): string {
  return str.replace(/[&<>"']/g, (c) => HTML_ESCAPE_MAP[c] as string);
}

function escapeTextWithBreaks(str: string): string {
  return escapeHtml(str).replace(/\n/g, "<br>");
}

export function valueToHtml(value: string, displayFor: (id: string) => string): string {
  if (!value) return "<p></p>";
  let html = "<p>";
  let lastIndex = 0;
  for (const match of value.matchAll(VARIABLE_MARKUP_RE)) {
    const matchIndex = match.index ?? 0;
    html += escapeTextWithBreaks(value.slice(lastIndex, matchIndex));
    const id = match[1];
    const label = displayFor(id);
    html += `<span data-type="mention" data-id="${escapeHtml(id)}" data-label="${escapeHtml(label)}"></span>`;
    lastIndex = matchIndex + match[0].length;
  }
  html += escapeTextWithBreaks(value.slice(lastIndex));
  html += "</p>";
  return html;
}
